import React from 'react';
import { useNavigate } from 'react-router-dom';
import Pricing from './Pricing';
import SafetyTraining from './SafetyTraining';
import ContactForm from './Form';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-badge">
              Virtual Reality &amp; WebGL Simulations
            </div>

            <div className="big-font">
              <p id="top-gap">Immersive HSE Learning</p>
              <p id="bold">Safety Training</p>
            </div>

            <p className="font-main">
              VIRSAT specializes in high-fidelity HSE, Learning, IT, and interactive WebGL gaming solutions for modern enterprises.
            </p>
            <p className="font-main">
              We deliver state-of-the-art 3D tools and VR simulations engineered to eliminate risks and elevate safety standards across the industry.
            </p>

            <div className="button-container">
              <button className="body-button" onClick={() => navigate('/pclicense')}>
                Get Access Now
              </button>
              <button className="body-button" onClick={() => navigate('/life-saving')}>
                Explore Courses
              </button>
            </div>

            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-num">7</span>
                <span className="hero-stat-label">Training modules</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-num">PC &amp; VR</span>
                <span className="hero-stat-label">Ready to deploy</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-num">Abu Dhabi</span>
                <span className="hero-stat-label">UAE headquarters</span>
              </div>
            </div>
          </div>

          <div className="hero-media">
            <div className="hero-image-frame">
              <img
                src="/mainImages/home-page-banner-image.jpg"
                alt="VIRSAT VR safety training in use"
                className="hero-image"
              />
              <div className="hero-chip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                VR &amp; PC Compatible
              </div>
            </div>
          </div>
        </div>
      </section>

      <SafetyTraining />
      <Pricing />
      <ContactForm />
    </div>
  );
};

export default HomePage;
